import { AccountReportsPage } from "@containers";
import { useEffect } from "react";
import { Strings } from "@constant";

export const AccountReports = () => {
  useEffect(() => {
    document.title = Strings.pageTitle("Account Reports");
  });

  return (
    <>
      <AccountReportsPage />
    </>
  );
};
